import { render, staticRenderFns } from "./offline_order_list.vue?vue&type=template&id=0a504898&scoped=true"
import script from "./offline_order_list.vue?vue&type=script&lang=js"
export * from "./offline_order_list.vue?vue&type=script&lang=js"
import style0 from "./offline_order_list.vue?vue&type=style&index=0&id=0a504898&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a504898",
  null
  
)

export default component.exports